import { Message } from "primereact/message"

export default function NoFederalRoadsMessage() {

    const messageContent = (
        <div className="message-content">
            <i className="pi pi-info-circle" /> <span>Нет федеральных дорог</span>
        </div>
    );

    return (
        <Message
            className="no-federal-roads-message"
            severity={undefined}
            content={messageContent}
        />
    )
}
